import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2, Mail, Phone, MapPin } from "lucide-react";
import { BRAND } from "../lib/brand";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 border-t border-white/10 bg-[#02020a] py-16"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1 flex flex-col gap-4">
          <Link to="/" className="flex items-center gap-3">
            <img src={BRAND.logo} alt={BRAND.name} className="h-12 w-12 rounded-full" />
            <span className="font-script text-2xl neon-gradient-text">{BRAND.name}</span>
          </Link>
          <p className="text-sm text-gray-400 leading-relaxed">{BRAND.tagline}</p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-[#00b4ff] mb-4">Explore</h4>
          <ul className="flex flex-col gap-2 text-sm text-gray-300">
            <li><Link data-testid="footer-link-shop" to="/shop" className="hover:text-white hover:neon-pink">Shop</Link></li>
            <li><Link data-testid="footer-link-menus" to="/menus" className="hover:text-white hover:neon-pink">Dessert Menu</Link></li>
            <li><Link data-testid="footer-link-daily-specials" to="/daily-specials" className="hover:text-white hover:neon-pink">Daily Specials</Link></li>
            <li><Link data-testid="footer-link-events" to="/events" className="hover:text-white hover:neon-pink">Events</Link></li>
            <li><Link data-testid="footer-link-faq" to="/faq" className="hover:text-white hover:neon-pink">FAQ</Link></li>
            <li><Link data-testid="footer-link-about" to="/about" className="hover:text-white hover:neon-pink">About</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-white hover:neon-pink">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-[#00b4ff] mb-4">Visit</h4>
          <ul className="flex flex-col gap-3 text-sm text-gray-300">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#ff1a8c]" /> {BRAND.address}</li>
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-[#ff1a8c]" /> {BRAND.phone}</li>
            <li>
              <a
                href={`mailto:${BRAND.email}`}
                data-testid="footer-email-button"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#ff1a8c]/60 text-white text-[0.72rem] uppercase tracking-[0.2em] font-semibold hover:bg-[#ff1a8c] hover:shadow-[0_0_18px_rgba(255,26,140,0.55)] transition-all"
              >
                <Mail className="w-3.5 h-3.5" /> Email Us
              </a>
            </li>
            <li className="text-gray-400">{BRAND.hours}</li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-[#00b4ff] mb-4">Follow</h4>
          <div className="flex items-center gap-3">
            <a href={BRAND.socials.instagram} target="_blank" rel="noreferrer" data-testid="footer-social-instagram" className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center hover:border-[#ff1a8c] hover:shadow-[0_0_18px_rgba(255,26,140,0.6)]">
              <Instagram className="w-4 h-4" />
            </a>
            <a href={BRAND.socials.tiktok} target="_blank" rel="noreferrer" data-testid="footer-social-tiktok" className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center hover:border-[#00b4ff] hover:shadow-[0_0_18px_rgba(0,180,255,0.6)]">
              <Music2 className="w-4 h-4" />
            </a>
            <a href={BRAND.socials.facebook} target="_blank" rel="noreferrer" data-testid="footer-social-facebook" className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center hover:border-[#ff1a8c] hover:shadow-[0_0_18px_rgba(255,26,140,0.6)]">
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-12">
        <hr className="hr-neon" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6">
          <button
            type="button"
            data-testid="footer-newsletter-cta"
            onClick={() => window.dispatchEvent(new Event("jdm:open-newsletter-popup"))}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#00b4ff]/50 text-[0.7rem] uppercase tracking-[0.22em] text-[#00b4ff] hover:bg-[#00b4ff]/10 hover:border-[#00b4ff] transition-all"
          >
            <Mail className="w-3 h-3" />
            Join the mailing list · 10% off first online order
          </button>
          <p className="text-xs text-gray-500 text-center tracking-[0.15em] uppercase">
            © {new Date().getFullYear()} {BRAND.name} · All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
